import { render, staticRenderFns } from "./DialogTestRegistri.vue?vue&type=template&id=0f0d8760&"
import script from "./DialogTestRegistri.vue?vue&type=script&lang=js&"
export * from "./DialogTestRegistri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports